ixModuleRouting("impactx.monitordashboard", {
    "/monitordashboard": {
        templateUrl: "modules/monitor/templates/monitordashboard.tmpl.html",
        controller: "MonitorDashboardCtrl as monitorDashboardCtrl",
        workspace: "monitor",
    },
    "/businessorder": {
        template: '<ixa-business-order-list></ixa-business-order-list>',
        templateUrl: "modules/monitor/templates/businessorder.html",
        process: "BusinessOrder",
        controller: "BusinessOrderListCtrl",
        controllerAs: "businessOrderListCtrl",
        workspace: "monitor",
    },
    "/businessorderitems": {
        template: '<ixa-business-order-item-list></ixa-business-order-item-list>',
        templateUrl: "modules/monitor/templates/businessorderitem.html",
        process: "BusinessOrder",
        controller: "BusinessOrderItemListCtrl",
        controllerAs: "businessOrderItemListCtrl",
        workspace: "monitor",
    },
    '/orderaccounting': {
        template: '<ixa-orderaccounting-list></ixa-orderaccounting-list>',
        process: 'OrderControlling',
        workspace: 'monitor',
    },
    '/monitordefault': {
        template: '<ixa-monitordefault></ixa-monitordefault>',
        workspace: 'monitor',
    },
    '/deliverynoteinvoicereport': {
        template: '<ixa-deliverynoteinvoicereport-list></ixa-deliverynoteinvoicereport-list>',
        process: 'DeliveryNoteInvoiceReport',
        workspace: 'monitor',
    },
    '/customerorderinvoicereport': {
        template: '<ixa-customerorderinvoicereport-list></ixa-customerorderinvoicereport-list>',
        process: 'CustomerOrderInvoiceReport',
        workspace: 'monitor',
    },
    '/deliverynoteunchecked': {
        template: '<ixa-delivery-note-unchecked-list></ixa-delivery-note-unchecked-list>',
        process: 'DeliveryNoteUncheckedMonitor',
        workspace: 'monitor',
    },
    '/invoicedeliveryabroad': {
        template: '<ixa-invoice-delivery-abroad-list></ixa-invoice-delivery-abroad-list>',
        process: 'InvoiceDeliveryAbroadMonitor',
        workspace: 'monitor',
    }
});
